module.exports = __webpack_public_path__ + "img/create-new-product.d743f06e.svg";